import { render, staticRenderFns } from "./addChangeMoney.vue?vue&type=template&id=6673c7c4&scoped=true&"
import script from "./addChangeMoney.vue?vue&type=script&lang=js&"
export * from "./addChangeMoney.vue?vue&type=script&lang=js&"
import style0 from "./addChangeMoney.vue?vue&type=style&index=0&id=6673c7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673c7c4",
  null
  
)

export default component.exports